import React, { useState, useEffect } from "react";
// import "../feedbackList/feedbackListForAdmin.scss";
import {
    Button,
    Card,
    Modal,
    OverlayTrigger,
    Table,
    Tooltip,
} from "react-bootstrap";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
// import FeedbackDetailsForAdmin from "./feedbackDetailsForAdmin";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allFeedbackList } from "../../service/api/user/allFeedbackList";
import deleteFeedbackApi from "../../service/api/user/deleteFeedbackById";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { getFeedbackById } from "../../service/api/user/getFeedbackById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtFeedbackList, txtFullName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import { callRequests } from "../../service/api/callHistory/callRequests";
const CallHistory = () => {
    const [basicModal, setBasicModal] = useState(false);
    const [initiColor, setInitiColor] = useState(true);
    const [sortingCol, setSortingCol] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [elements, setElements] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);

    const [sortByValue, setSortByValue] = useState("DESC");
    const [columnName, setColumnName] = useState("created_date_dtm");
    const [searchValue, setSearchValue] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);
    const [dataToModal, setDataToModal] = useState(false);
    const [handleToaster, setHandleToaster] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [resMessage, setResMessage] = useState("");
    const [firstCheck, setFirstCheck] = useState(false);
    const [customeSkeletonLoaing, setCustomeSkeletonLoaing] = useState(false);

    const rows = elements;

    const copyToClipboard = () => {
        setResMessage("Link copied to clipboard!");
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 11000);
    }



    function onLoad() {
        setSkeltonVal(true);
        setCustomeSkeletonLoaing(true);

        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            page_index: page,
            page_size: pageSize,
            sorting_order: sortByValue,
            sorting_column_name: columnName,
            search_area: searchValue,
            is_accepted_flag: 2,
        };
        dispatch(
            callRequests(details, (res) => {
                console.log(res.data);

                console.log(res.total_count)

                setElements(res.data);
                setCustomeSkeletonLoaing(false);
                setTotalNoRecord(res.total_count);
                if (res.total_count % pageSize === 0) {
                    setTotalPage(parseInt(res.total_count / pageSize));
                } else {
                    setTotalPage(parseInt(res.total_count / pageSize + 1));
                }

                if (res.data.data.length === 0) {
                    setTimeout(() => {
                        setSkeltonVal(true);
                    }, "3000");
                } else {
                    setSkeltonVal(true);
                }
            }, (err) => {
                console.log(err);
            })
        )
    }

    const handleColumnName = (name) => {
        setSortingCol(false);
        setColumnName(name);

        if (sortByValue === "ASC") {
            setSortByValue("DESC");
        }
        if (sortByValue === "DESC") {
            setSortByValue("ASC");
        }
    };

    const handleOrderValue = (order) => {
        setSortByValue(order);
    };

    const handleSearch = (e) => {
        // setPage(1)

        setSearchValue(e.target.value);
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
            setColumnName('')
        }
    };

    const handleChangeRowsPerPage = (e) => {
        // console.log(e)
        setSearchValue("");
        setPage(1);
        setPageSize(e.target.value);
    };

    const onChangePage = (e, p) => {
        // setPage(p);
        setPage(e);
    };



    useEffect(() => {
        onLoad();
    }, [sortByValue, pageSize, page, columnName]);

    function onLoadSearch() {
        setSkeltonVal(true);

        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            page_index: 1,
            page_size: pageSize,
            sorting_order: sortByValue,
            sorting_column_name: "",
            search_area: searchValue,
            is_accepted_flag: 2,
        };
        dispatch(
            callRequests(details, (res) => {
                console.log(res.data);

                console.log(res.total_count)

                setElements(res.data);
                setCustomeSkeletonLoaing(false);
                setTotalNoRecord(res.total_count);
                if (res.total_count % pageSize === 0) {
                    setTotalPage(parseInt(res.total_count / pageSize));
                } else {
                    setTotalPage(parseInt(res.total_count / pageSize + 1));
                }

                if (res.data.data.length === 0) {
                    setTimeout(() => {
                        setSkeltonVal(true);
                    }, "3000");
                } else {
                    setSkeltonVal(true);
                }
            }, (err) => {
                console.log(err);
            })
        )
    }
    useEffect(() => {
        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(onLoadSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValue]);

    const percentage = 70;

    const tooltipCopyTxt = (
        <Tooltip id="tooltip">
            <strong>Copy to clipboard</strong>
        </Tooltip>
    );

    // Modal triggers for the Feedback details
    const [showFeedbackDetails, setShowFeedbackDetails] = useState(false);

    const handleCloseFeedbackDetails = () => {

        setShowFeedbackDetails(false)
    };


    const [callDetailsObj, setCallDetailsObj] = useState({});
    const [time, setTime] = useState(0);


    return (
        <div>
            <Card>
                <div className="d-flex align-items-center service-requests-main">
                    <div className="waiting-dashboard-title">{"Call Histroy"}</div>

                    <div
                        className="d-flex justify-content-between slider-box-search"
                        style={{ width: "60%" }}>
                        <div className="admin-btn-group-container d-flex"></div>

                        <div>
                            {/* <div className="admin-input-group input-group">
                <span className="input-group-text search-input-icon">
                  <i className="bi bi-search" style={{ fontSize: "16px" }}></i>
                </span>
                <input
                  type="text"
                  className="form-control search-input"
                  id="val-username1"
                  placeholder="Search Service.."
                  name="username"
                />
              </div> */}
                        </div>
                    </div>
                </div>
                <Card.Body>

                    <PaginationAndSearching
                        handleSearch={handleSearch}
                        searchValue={searchValue}
                        defaultValue={pageSize}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        totalCount={totalPage}
                        onChange={onChangePage}
                    />

                    <Table responsive>
                        <thead style={{ background: "#8080801c" }}>
                            <tr>
                                <th style={{ cursor: "pointer" }} onClick={() => { handleColumnName("created_date_dtm"); setFirstCheck(true) }}>
                                    <div className="d-flex align-items-center">
                                        <strong>{txtCreatedDate}</strong>
                                        {sortingCol && (
                                            <i
                                                style={{ fontSize: "11px" }}
                                                className="fa fa-fw fa-sort"></i>
                                        )}
                                        {sortByValue === "DESC" && columnName === "created_date_dtm" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                                        {sortByValue === "ASC" && columnName === "created_date_dtm" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                                    </div>
                                </th>

                                <th style={{ cursor: "" }}
                                    onClick={() => {
                                        // handleColumnName("receiver_name"); setFirstCheck(true) 
                                    }}>
                                    <div className="d-flex align-items-center">
                                        <strong>{"Receiver Name"}</strong>
                                        {/* {sortingCol && (
                                            <i
                                                style={{ fontSize: "11px" }}
                                                className="fa fa-fw fa-sort"></i>
                                        )}
                                        {sortByValue === "DESC" && columnName === "receiver_name" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                                        {sortByValue === "ASC" && columnName === "receiver_name" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>} */}

                                    </div>
                                </th>

                                {/* <th style={{ cursor: "" }} onClick={() => {
                                }}>
                                    <div className="d-flex align-items-center">
                                        <strong>{lblEmail}</strong>
                                    </div>
                                </th>
                                <th style={{ cursor: "" }} onClick={() => {
                                }}>
                                    <div className="d-flex align-items-center">
                                        <strong>{lblPhoneNumber}</strong>
                                    </div>
                                </th> */}

                                <th style={{ cursor: "" }} onClick={() => {
                                    // handleColumnName("message_chr"); setFirstCheck(true) 
                                }}>
                                    <div className="d-flex align-items-center">
                                        <strong>{"Message"}</strong>
                                        {/* {sortingCol && (
                                            <i
                                                style={{ fontSize: "11px" }}
                                                className="fa fa-fw fa-sort"></i>
                                        )}

                                        {sortByValue === "DESC" && columnName === "message_chr" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                                        {sortByValue === "ASC" && columnName === "message_chr" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>} */}

                                    </div>
                                </th>


                                <th>
                                    <div className="d-flex align-items-center">
                                        <strong>{"Invite Link"}</strong>
                                        {/* <i className="fa fa-fw fa-sort"></i> */}
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>

                            {customeSkeletonLoaing ?
                                <SkeletonTableRow cols={4} /> :
                                <>
                                    {rows.length > 0 ?
                                        <>
                                            {rows.map((element, index) => {
                                                return (
                                                    <>
                                                        <tr
                                                            key={index}
                                                            className="notification-rows"
                                                            style={{ fontSize: "13px" }}>
                                                            <td>
                                                                {" "}
                                                                {new Intl.DateTimeFormat("en-US", {
                                                                    year: "numeric",
                                                                    month: "long",
                                                                    day: "numeric",
                                                                }).format(element?.created_date_dtm + "000")}
                                                            </td>

                                                            <td
                                                                style={{
                                                                    borderTopLeftRadius: "20px !important",
                                                                    borderBottomLeftRadius: "20px !important",
                                                                }}>
                                                                {element.receiver_name == "" ||
                                                                    element.receiver_name == null
                                                                    ? "NA"
                                                                    : element.receiver_name}
                                                            </td>



                                                            {/* <td>
                                                                {element.receiver_email == "" || element.receiver_email == " " || element.receiver_email == null
                                                                    ? "NA"
                                                                    : element.receiver_email}
                                                            </td>

                                                            <td>
                                                                {(element?.receiver_phone_number == "" || element?.receiver_phone_number == null) ? ('NA') : <InternationalPhoneFormat countryCode={element?.receiver_country_code} phoneNumber={`${element?.receiver_phone_number}`} />}
                                                            </td> */}

                                                            <td>{(element.message_chr == "" || element.message_chr == null) ? 'NA' : element.message_chr}</td>


                                                            <td>
                                                                <div
                                                                    className="d-flex align-items-center"
                                                                    style={{ justifyContent: "space-around" }}>
                                                                    <OverlayTrigger placement="top" overlay={tooltipCopyTxt}>
                                                                        <div
                                                                            onClick={() => {
                                                                                navigator.clipboard.writeText(`Chill video call link: ${element?.video_link_chr}`);
                                                                                copyToClipboard();
                                                                            }}
                                                                            className="d-flex align-items-center justify-content-center"
                                                                            style={{
                                                                                color: "#0AC947",
                                                                                fontSize: "21px",
                                                                                cursor: "pointer",
                                                                            }}>
                                                                            <i className="bi bi-files"></i>
                                                                        </div>
                                                                    </OverlayTrigger>


                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </>
                                                );
                                            })}
                                        </> :
                                        <tr style={{ fontSize: '13px', backgroundColor: '#fff', }}>
                                            <td colSpan="6">{txtNoRecordsFound}</td>
                                        </tr>
                                    }
                                </>}

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={resMessage} />}
        </div>
    );
};

export default CallHistory;
